import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * [기본 로그 > SNMP Trap] 설정 API
 */
export default {
  /**
   * [Snmptrap설정 > 장비별 수집 설정] 장비별 Snmptrap 수집 설정 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getSnmptrapObjList(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/get-snmptrap-obj-list.do`, params);
  },
  /**
   * [Snmptrap설정 > 장비별 수집 설정] 장비별 Snmptrap 수집 여부 설정을 업데이트한다.
   * @author Minyeong
   * @return {[type]} 수집 여부가 설정된 Obj List
   */
  updateSnmptrapGroupSetList(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/update-snmptrap-group-set-list.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getSnmptrapSetDetail() {
    return axios.get(`${baseUrl}/settings/snmptrap/get-snmptrap-set-detail.do`);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] 트랩 추가 팝업의 Trap Generic Set 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getTrapGenericSet() {
    return axios.get(`${baseUrl}/settings/snmptrap/get-trap-generic-set.do`);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap을 추가한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertSnmptrap(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/insert-snmptrap.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap을 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteSnmptrap(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/delete-snmptrap.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap을 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSnmptrap(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/update-snmptrap.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] 선택한 트랩의 SubOid 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSubOidList(params) {
    return axios.get(`${baseUrl}/settings/snmptrap/get-snmptrap-sub-oid.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] 선택한 트랩의 SubOid를 추가한다.
   * @author Minyeong
   * @param  {[type]} querystring SubOid의 Form 데이터
   * @param  {[type]} payload SubOid의 메시지 데이터
   * @return {[type]}        [description]
   */
  insertSubOid(querystring, payload) {
    return axios.post(`${baseUrl}/settings/snmptrap/insert-sub-oid.do?${querystring}`, payload);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] MibOid별 메시지 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMibOidValue(params) {
    return axios.get(`${baseUrl}/settings/snmptrap/get-mib-oid-value`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] SubOid를 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteSubOid(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/delete-sub-oid.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] SubOid의 메시지 수집 여부를 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateMsgFlagSubOid(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/update-msg-flag-sub-oid.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] SubOid를 수정한다.
   * @author Minyeong
   * @param  {[type]} querystring SubOid의 Form 데이터
   * @param  {[type]} payload     SubOid의 메시지 데이터
   * @return {[type]}             [description]
   */
  updateSubOid(querystring, payload) {
    return axios.post(`${baseUrl}/settings/snmptrap/update-sub-oid.do?${querystring}`, payload);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap의 이벤트 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSnmptrapEventRuleList(params) {
    return axios.get(`${baseUrl}/settings/snmptrap/get-snmptrap-event-rule-list.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap의 이벤트를 추가한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertSnmptrapEventRule(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/insert-snmptrap-event-rule.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap의 이벤트를 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateSnmptrapEventRule(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/update-snmptrap-event-rule.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] Snmptrap의 이벤트를 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteSnmptrapEventRule(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/delete-snmptrap-event-rule.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] MIB 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getMibList() {
    return axios.get(`${baseUrl}/settings/snmptrap/get-mib-list.do`);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] MIB 파일을 삭제한다.
   * @author Minyeong
   * @param  {[Object]} params [MIB 객체]
   * @return {[type]}        [description]
   */
  deleteMibfile(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/delete-mibfile.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] 선택된 MIB로 트랩 목록을 조회해온다.
   * @author Minyeong
   * @param  {[Object]} params [MIB Name]
   * @return {[type]}        [description]
   */
  getMibTrapList(params) {
    return axios.get(`${baseUrl}/settings/snmptrap/get-mib-trap-list.do`, params);
  },
  /**
   * [Snmptrap설정 > 트랩별 수집 설정] MIB 파일을 저장한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertMibfile(params) {
    return axios.post(`${baseUrl}/settings/snmptrap/insert-mibfile.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/snmptrap-settings.js